import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\n<path d=\"M5.25009 9.43253L2.81759 7.00003L1.98926 7.82253L5.25009 11.0834L12.2501 4.08336L11.4276 3.26086L5.25009 9.43253Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol